import React from 'react';
import { useStandards } from './standards-provider';
import StandardItemForm from '../../components/forms/standard-item-form';
import StandardItemFormContext from '../../components/forms/standard-item-form-context';

const StandardItemEdit = () => {
  const {
    selectedStandardItem,
    multipleOptions,
    updateStandardItem,
    savedFormValues,
    setSavedFormValues,
  } = useStandards();

  const isSinINBnPeriod =
    selectedStandardItem?.isStandardItemInBetweenBidPeriods;
  const isReadOnly = selectedStandardItem?.isStandardItemInOpenSolicitation;
  const isSinInContractYear =
    selectedStandardItem?.isStandardItemInContractYear;
  const isSinPartiallyEditable = selectedStandardItem?.canPartialEdit;
  const sinSelectedTags = selectedStandardItem?.tags?.value || [];

  const handleSave = async (data) => {
    // Save form values before submission
    setSavedFormValues(data);

    const tags = { value: [] };
    if (data?.tags) {
      tags.value = data.tags;
    }
    const standardItemInput = {
      ...data,
      tags,
      contentId: selectedStandardItem?.content?.id,
      year: Number.parseInt(data?.year, 10),
      isActive: Number.parseInt(data?.isActive, 10),
    };
    await updateStandardItem({
      variables: {
        id: selectedStandardItem.id,
        standarditem: standardItemInput,
      },
    });
  };

  return (
    <StandardItemFormContext
      standardItem={selectedStandardItem}
      savedValues={savedFormValues}
    >
      <StandardItemForm
        formId="standard-item-edit-form"
        standardItemId={selectedStandardItem?.id}
        standardItemTags={multipleOptions?.tags}
        fedStandardCodes={multipleOptions?.fedStandardCode}
        vehicleGroups={multipleOptions?.vehicleGroup}
        vehicleTypes={multipleOptions?.vehicleType}
        years={multipleOptions?.futureYears}
        handleSave={handleSave}
        fastCodes={multipleOptions?.fastCodes}
        isAddForm={false}
        isReadOnly={isReadOnly}
        isPartialEditable={isSinPartiallyEditable}
        sinSelectedTags={sinSelectedTags}
        isSinINBnPeriod={isSinINBnPeriod}
        isSinInContractYear={isSinInContractYear}
      />
    </StandardItemFormContext>
  );
};

export default StandardItemEdit;
